import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

interface UseGetUsersListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUsersList = async (data: any) =>
  await axiosAuth.post(`${GET_USERS}/grid`, data);

const useGetUsersList = ({
  data,
  queryParams,
}: UseGetUsersListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => getUsersList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetUsersList;
